/**
 * Appointment Planner - Users REST API
 * Appointment Planner Users Service REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: valeriu.craciun@kronsoft.ro
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { CmsAppTypeEnumDTO } from '../model/models';
import { CmsPageContentDTO } from '../model/models';
import { CmsPageTypeEnumDTO } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class ContentManagementSystemService {

    protected basePath = 'http://localhost:8512';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Create or update cms page content
     * @param type 
     * @param pageType 
     * @param cmsPageContentDTO Cms page request body
     * @param newRelease Indicates whether it is a new release update or a simple text change
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createOrUpdatePageContent(type: CmsAppTypeEnumDTO, pageType: CmsPageTypeEnumDTO, cmsPageContentDTO: CmsPageContentDTO, newRelease?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CmsPageContentDTO>;
    public createOrUpdatePageContent(type: CmsAppTypeEnumDTO, pageType: CmsPageTypeEnumDTO, cmsPageContentDTO: CmsPageContentDTO, newRelease?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CmsPageContentDTO>>;
    public createOrUpdatePageContent(type: CmsAppTypeEnumDTO, pageType: CmsPageTypeEnumDTO, cmsPageContentDTO: CmsPageContentDTO, newRelease?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CmsPageContentDTO>>;
    public createOrUpdatePageContent(type: CmsAppTypeEnumDTO, pageType: CmsPageTypeEnumDTO, cmsPageContentDTO: CmsPageContentDTO, newRelease?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling createOrUpdatePageContent.');
        }
        if (pageType === null || pageType === undefined) {
            throw new Error('Required parameter pageType was null or undefined when calling createOrUpdatePageContent.');
        }
        if (cmsPageContentDTO === null || cmsPageContentDTO === undefined) {
            throw new Error('Required parameter cmsPageContentDTO was null or undefined when calling createOrUpdatePageContent.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (newRelease !== undefined && newRelease !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>newRelease, 'newRelease');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<CmsPageContentDTO>(`${this.configuration.basePath}/cms-pages/${encodeURIComponent(String(type))}/${encodeURIComponent(String(pageType))}`,
            cmsPageContentDTO,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get content for a specific application type and page type
     * @param type 
     * @param pageType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPageContent(type: CmsAppTypeEnumDTO, pageType: CmsPageTypeEnumDTO, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CmsPageContentDTO>;
    public getPageContent(type: CmsAppTypeEnumDTO, pageType: CmsPageTypeEnumDTO, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CmsPageContentDTO>>;
    public getPageContent(type: CmsAppTypeEnumDTO, pageType: CmsPageTypeEnumDTO, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CmsPageContentDTO>>;
    public getPageContent(type: CmsAppTypeEnumDTO, pageType: CmsPageTypeEnumDTO, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling getPageContent.');
        }
        if (pageType === null || pageType === undefined) {
            throw new Error('Required parameter pageType was null or undefined when calling getPageContent.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<CmsPageContentDTO>(`${this.configuration.basePath}/cms-pages/${encodeURIComponent(String(type))}/${encodeURIComponent(String(pageType))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get content for a specific application type
     * @param type 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPageContents(type: CmsAppTypeEnumDTO, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<CmsPageContentDTO>>;
    public getPageContents(type: CmsAppTypeEnumDTO, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<CmsPageContentDTO>>>;
    public getPageContents(type: CmsAppTypeEnumDTO, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<CmsPageContentDTO>>>;
    public getPageContents(type: CmsAppTypeEnumDTO, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling getPageContents.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<CmsPageContentDTO>>(`${this.configuration.basePath}/cms-pages/${encodeURIComponent(String(type))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch an existing cms page content
     * @param type 
     * @param pageType 
     * @param requestBody Patch request body
     * @param newRelease Indicates whether it is a new release update or a simple text change
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePageContent(type: CmsAppTypeEnumDTO, pageType: CmsPageTypeEnumDTO, requestBody: { [key: string]: any; }, newRelease?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CmsPageContentDTO>;
    public updatePageContent(type: CmsAppTypeEnumDTO, pageType: CmsPageTypeEnumDTO, requestBody: { [key: string]: any; }, newRelease?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CmsPageContentDTO>>;
    public updatePageContent(type: CmsAppTypeEnumDTO, pageType: CmsPageTypeEnumDTO, requestBody: { [key: string]: any; }, newRelease?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CmsPageContentDTO>>;
    public updatePageContent(type: CmsAppTypeEnumDTO, pageType: CmsPageTypeEnumDTO, requestBody: { [key: string]: any; }, newRelease?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling updatePageContent.');
        }
        if (pageType === null || pageType === undefined) {
            throw new Error('Required parameter pageType was null or undefined when calling updatePageContent.');
        }
        if (requestBody === null || requestBody === undefined) {
            throw new Error('Required parameter requestBody was null or undefined when calling updatePageContent.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (newRelease !== undefined && newRelease !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>newRelease, 'newRelease');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.patch<CmsPageContentDTO>(`${this.configuration.basePath}/cms-pages/${encodeURIComponent(String(type))}/${encodeURIComponent(String(pageType))}`,
            requestBody,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
